<div class="basic-form flex gap-28 px-28">
  <app-token-info class="relative basic flex-1"></app-token-info>
  <app-faq class="flex-1"></app-faq>
</div>
